import { render, staticRenderFns } from "./FoodQuestionnaire.vue?vue&type=template&id=ca82972c&scoped=true&"
import script from "./FoodQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./FoodQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./FoodQuestionnaire.vue?vue&type=style&index=0&id=ca82972c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca82972c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VBtnToggle,VCheckbox,VCol,VForm,VIcon,VRow,VSheet})
